import React from 'react';
import './h1-desktop.css'
const H1Desktop = ({value, styleClass}) => {
    return (
        <>
            <p className={styleClass}>{value}</p>
        </>
    );
}

export default H1Desktop;
